import { ErrorScreen } from './error-screen'

ErrorScreen.define('fp-error-screen')

declare global {
  interface HTMLElementTagNameMap {
    'fp-error-screen': ErrorScreen;
  }
}

export default ErrorScreen
